import { render, staticRenderFns } from "./dataPackage.vue?vue&type=template&id=4e66bf3e&scoped=true"
import script from "./dataPackage.vue?vue&type=script&lang=js"
export * from "./dataPackage.vue?vue&type=script&lang=js"
import style0 from "./dataPackage.vue?vue&type=style&index=0&id=4e66bf3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66bf3e",
  null
  
)

export default component.exports